import React from 'react';
import Icon from '../../../components/AppIcon';

const KPICard = ({ title, value, change, changeType, icon, iconColor }) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 transition-smooth hover:shadow-md h-full flex flex-col min-w-0">
      <div className="flex items-start justify-between mb-3 md:mb-4 gap-2">
        <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-md flex-shrink-0">
          <Icon name={icon} size={20} color={iconColor || 'var(--color-primary)'} className="md:w-6 md:h-6" />
        </div>
        {change && (
          <div className={`flex items-center gap-1 flex-shrink-0 ${getChangeColor()}`}>
            <Icon name={getChangeIcon()} size={14} color="currentColor" className="md:w-4 md:h-4" />
            <span className="data-text text-xs md:text-sm font-medium whitespace-nowrap">{change}</span>
          </div>
        )}
      </div>
      <h3 className="caption text-xs md:text-sm text-muted-foreground mb-2 break-words overflow-hidden line-clamp-2">{title}</h3>
      <p className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground break-words overflow-hidden line-clamp-1">{value}</p>
    </div>
  );
};

export default KPICard;